import(/* webpackMode: "eager" */ "/srv/AltenB2B/node_modules/next/font/google/target.css?{\"path\":\"src/modules/auth/templates/index.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/AltenB2B/src/modules/auth/components/login-box/index.tsx");
